import React from "react"
import BuySteps from "../BuySteps"
import { Container } from "./styles"
import { useSelector } from "react-redux"
import FloatingWhatsapp from "../FloatingWhatsapp"
import { ToastContainer } from "react-toastify"
import { PageBackground, PageContainer } from "../../styles/Container"
import RodapeIdentidadeVisual from "../RodapeIdentidadeVisual"

const BuyStepsTemplate = ({ children, history, step }) => {
    const { telefone_whatsapp, exibir_whatsapp, link_para_contato } = useSelector((state) =>
        state.store.data == null ? "" : state.store.data.empresa
    );

    return (
        <Container>
            <ToastContainer autoClose={2500} />
            <BuySteps step={step} history={history} />
            <PageBackground>
                <PageContainer>{children}</PageContainer>
            </PageBackground>
            <RodapeIdentidadeVisual />
            {exibir_whatsapp && (telefone_whatsapp || link_para_contato) && <FloatingWhatsapp contactLink={link_para_contato} whatsappPhoneNumber={telefone_whatsapp ? `55${telefone_whatsapp.replace(/\D/g, '')}` : undefined} />}
        </Container>
    )
}

export default BuyStepsTemplate;
